/** Shopify CDN: Minification failed

Line 12:2 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 13:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 19:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 22:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      if (this.variantLabels) {
        // Bind to on:variant:change event for this product
        const variantPicker = this.closest('.product').querySelector('variant-picker');
        if (variantPicker) {
          variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        }

        if (this.dataset.currentVariantId) {
          this.setVisibleVariantLabel(this.dataset.currentVariantId);
        }
      }
    }

    /**
     * Sets the visible variant variantLabels.
     * @param {string} variantId - The variant id
     */
    setVisibleVariantLabel(variantId) {
      this.variantLabels.forEach((variantLabel) => {
        variantLabel.hidden = variantLabel.dataset.variantId.toString() !== variantId.toString();
      });
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.setVisibleVariantLabel(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-label', VariantLabel);
}
